// source: pbtypes/gen/cellular_sim_configs/sim_config_override.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_access_mode_pb = require('../../../pbtypes/gen/cellular_sim_configs/access_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_access_mode_pb);
var pbtypes_gen_cellular_sim_configs_auth_type_pb = require('../../../pbtypes/gen/cellular_sim_configs/auth_type_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_auth_type_pb);
var pbtypes_gen_cellular_sim_configs_band_pb = require('../../../pbtypes/gen/cellular_sim_configs/band_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_band_pb);
goog.exportSymbol('proto.cellular_sim_configs.SimConfigOverride', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.SimConfigOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cellular_sim_configs.SimConfigOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.SimConfigOverride.displayName = 'proto.cellular_sim_configs.SimConfigOverride';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.SimConfigOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.SimConfigOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimConfigOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
band: (f = msg.getBand()) && pbtypes_gen_cellular_sim_configs_band_pb.Band.toObject(includeInstance, f),
bandSet: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
requestedAccessMode: (f = msg.getRequestedAccessMode()) && pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.toObject(includeInstance, f),
requestedAccessModeSet: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
username: jspb.Message.getFieldWithDefault(msg, 5, ""),
usernameSet: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
password: jspb.Message.getFieldWithDefault(msg, 7, ""),
passwordSet: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
apn: jspb.Message.getFieldWithDefault(msg, 9, ""),
apnSet: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
authType: jspb.Message.getFieldWithDefault(msg, 11, 0),
authTypeSet: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.SimConfigOverride}
 */
proto.cellular_sim_configs.SimConfigOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.SimConfigOverride;
  return proto.cellular_sim_configs.SimConfigOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.SimConfigOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.SimConfigOverride}
 */
proto.cellular_sim_configs.SimConfigOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_cellular_sim_configs_band_pb.Band;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_band_pb.Band.deserializeBinaryFromReader);
      msg.setBand(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBandSet(value);
      break;
    case 3:
      var value = new pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.deserializeBinaryFromReader);
      msg.setRequestedAccessMode(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestedAccessModeSet(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsernameSet(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPasswordSet(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setApn(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApnSet(value);
      break;
    case 11:
      var value = /** @type {!proto.cellular_sim_configs.AuthType.Enum} */ (reader.readEnum());
      msg.setAuthType(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuthTypeSet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.SimConfigOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.SimConfigOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimConfigOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_cellular_sim_configs_band_pb.Band.serializeBinaryToWriter
    );
  }
  f = message.getBandSet();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRequestedAccessMode();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.serializeBinaryToWriter
    );
  }
  f = message.getRequestedAccessModeSet();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsernameSet();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPasswordSet();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getApn();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getApnSet();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAuthType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getAuthTypeSet();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional Band band = 1;
 * @return {?proto.cellular_sim_configs.Band}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getBand = function() {
  return /** @type{?proto.cellular_sim_configs.Band} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_band_pb.Band, 1));
};


/**
 * @param {?proto.cellular_sim_configs.Band|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
*/
proto.cellular_sim_configs.SimConfigOverride.prototype.setBand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.clearBand = function() {
  return this.setBand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.hasBand = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool band_set = 2;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getBandSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setBandSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AccessMode requested_access_mode = 3;
 * @return {?proto.cellular_sim_configs.AccessMode}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getRequestedAccessMode = function() {
  return /** @type{?proto.cellular_sim_configs.AccessMode} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode, 3));
};


/**
 * @param {?proto.cellular_sim_configs.AccessMode|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
*/
proto.cellular_sim_configs.SimConfigOverride.prototype.setRequestedAccessMode = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.clearRequestedAccessMode = function() {
  return this.setRequestedAccessMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.hasRequestedAccessMode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool requested_access_mode_set = 4;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getRequestedAccessModeSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setRequestedAccessModeSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string username = 5;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool username_set = 6;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getUsernameSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setUsernameSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string password = 7;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool password_set = 8;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getPasswordSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setPasswordSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string apn = 9;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getApn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setApn = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool apn_set = 10;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getApnSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setApnSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional AuthType.Enum auth_type = 11;
 * @return {!proto.cellular_sim_configs.AuthType.Enum}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getAuthType = function() {
  return /** @type {!proto.cellular_sim_configs.AuthType.Enum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.cellular_sim_configs.AuthType.Enum} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setAuthType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional bool auth_type_set = 12;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.getAuthTypeSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfigOverride} returns this
 */
proto.cellular_sim_configs.SimConfigOverride.prototype.setAuthTypeSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


goog.object.extend(exports, proto.cellular_sim_configs);
